import type { PhoneNumber } from '@/scopes/checkout/domain/types'

export interface StepsTabs {
  steps: {
    activeStep?: string
    items?: {
      text: string
      disabled: boolean
      completed: boolean
      link?: {
        href?: string
        target?: string
        title?: string
      }
    }[]
  }
}

export interface GroupStatusApiResponse {
  isValid: boolean
  totalOccupancy: number
  currentOccupancy: number
  departureDate: string
  subscriptionDateLimit: string
  groupName: string
  subscriptionNonValidReasons: string[]
  availableSlot: GroupSlotApiResponse
}

export interface GroupSlotApiResponse {
  bookingNumber: number
  bookingCustomerId: number
}

export type ErrorReason = 'None' | 'InternalError' | 'ParticipantAlreadyExists'

export interface AddParticipantApiResponse {
  isSuccess: boolean
  errorMessage: string
  data: {
    bookingNumber: number
    bookingCustomerId: number
    groupName: string
    errorReason: ErrorReason
  }
}

export interface GroupStatus {
  isValid: boolean
  groupName: string
  status: 'expired' | 'success' | 'full' | 'error'
  childBookingNumber: number
  bookingCustomerId: number
  errorReason?: ErrorReason

}

export const titleRadioGroupOptions = ['mr', 'ms'] as const
type TitleRadioGroupOption = (typeof titleRadioGroupOptions)[number]

export interface PersonalDataFormInput {
  title: TitleRadioGroupOption
  firstName: string
  lastName: string
  birthDate: string
  email: string
  mobilePhoneNumber: PhoneNumber | null
  emergencyPhoneNumber: PhoneNumber | null
}

export interface PersonalDataFormInputPayload {
  title: TitleRadioGroupOption
  firstName: string
  lastName: string
  birthDate: string
  email: string
  mobilePhoneNumber: string | null
  emergencyPhoneNumber: string | null
}

export interface SubscribeParticipant {
  isValid: boolean
  groupName: string
  status: 'expired' | 'success' | 'full' | 'error'
  childBookingNumber: number
  bookingCustomerId: number
}
